// extracted by mini-css-extract-plugin
export default {"container":"Home_container__s7pz6","home":"Home_home__LnHSa","avatarBox":"Home_avatarBox__402N8"};